import { Check, Building2, GraduationCap, Briefcase, HeartPulse, Users, Sparkles } from "lucide-react";
import { EMAIL, PHONE } from "@/data/content";

const DESIGNED_FOR = [
  { icon: Briefcase, label: "Employee wellness programs" },
  { icon: Building2, label: "Corporations" },
  { icon: HeartPulse, label: "Health fairs" },
  { icon: Sparkles, label: "Wellness fairs" },
  { icon: Users, label: "Retreats" },
  { icon: Briefcase, label: "Law firms" },
  { icon: Briefcase, label: "Financial firms" },
  { icon: HeartPulse, label: "Healthcare organizations" },
  { icon: GraduationCap, label: "Universities" },
];

const INCLUDES = [
  "Burnout prevention education",
  "Nervous system training",
  "Breathwork exercises",
  "Workplace acupressure",
  "Ear Seed Bar",
  "Recovery guide",
  "Q&A",
];

export default function WellnessPopUp() {
  const subject = encodeURIComponent("Wellness Pop-up inquiry");
  const body = encodeURIComponent(
    "Hi Joannie,\n\nI'd love to bring a Sano Wellness Pop-up to our organization.\n\nOrganization: \nApproximate group size: \nLocation: \nProposed dates: \nWhat your team needs most: \n\nThank you,\n"
  );

  return (
    <section
      id="wellness-popup"
      className="relative py-28 lg:py-36 overflow-hidden"
      style={{ background: "var(--sano-ink)", color: "var(--sano-bg)" }}
      data-testid="wellness-popup-section"
    >
      {/* Soft background photo */}
      <div
        className="absolute inset-0 opacity-15 pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1497366216548-37526070297c?fm=jpg&q=80&w=2000&auto=format&fit=crop')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-hidden="true"
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-4" style={{ color: "var(--sano-olive)" }}>
              Sano Wellness Pop-up · For Your Team
            </div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
              Bring the practice <em className="italic" style={{ color: "#C8C2B0" }}>to your people</em>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base leading-relaxed opacity-90">
              A mobile, evidence-informed wellness experience built for the
              modern workplace, conference, retreat, or campus. Designed by a
              Bronx-based licensed acupuncturist with over a decade of clinical
              practice — calibrated to actually move the needle on burnout.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Designed for */}
          <div className="lg:col-span-7">
            <div
              className="eyebrow mb-6"
              style={{ color: "#C8C2B0" }}
              data-testid="popup-designed-for"
            >
              Designed for
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              {DESIGNED_FOR.map((d) => {
                const Icon = d.icon;
                return (
                  <div
                    key={d.label}
                    className="flex items-center gap-4 p-5 border"
                    style={{
                      borderColor: "rgba(255,255,255,0.12)",
                      background: "rgba(255,255,255,0.04)",
                    }}
                  >
                    <Icon size={20} strokeWidth={1.25} style={{ color: "var(--sano-olive)" }} />
                    <span className="text-sm">{d.label}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Includes */}
          <div className="lg:col-span-5">
            <div
              className="p-8 lg:p-10 h-full"
              style={{
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.12)",
              }}
              data-testid="popup-includes"
            >
              <div className="eyebrow mb-6" style={{ color: "#C8C2B0" }}>
                Includes
              </div>
              <ul className="space-y-4 mb-10">
                {INCLUDES.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-base leading-relaxed">
                    <Check size={18} strokeWidth={1.5} className="shrink-0 mt-1" style={{ color: "var(--sano-olive)" }} />
                    {item}
                  </li>
                ))}
              </ul>

              <a
                href={`mailto:${EMAIL}?subject=${subject}&body=${body}`}
                className="inline-flex items-center justify-center w-full px-6 py-3.5 rounded-full text-sm font-medium"
                style={{ background: "var(--sano-olive)", color: "var(--sano-bg)" }}
                data-testid="popup-inquire-btn"
              >
                Request a Wellness Pop-up
              </a>
              <p className="text-xs mt-4 opacity-80 text-center">
                Or text {PHONE} · email {EMAIL}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
